import * as React from 'react';
import AdminSisDashboardContainer from 'admin/rostering/containers/AdminSisDashboardContainer';
import View from 'components/View';

type Props = {
  orgId: number;
};

function AdminSisSync(props: Props) {
  const { orgId } = props;

  return (
    <View scroll>
      <AdminSisDashboardContainer orgId={orgId} />
    </View>
  );
}

export default AdminSisSync;
